import React from 'react';
import { Box, Typography, Dialog, IconButton, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import useStyles from './useStyles';
import { TWorkExperience } from '../../../../types/User';
import WorkExperienceCard from '../../../../components/Card/WorkExperienceCard';

const useStyle = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
  },
}));
interface WorkDialogProps {
  workExperience: TWorkExperience[];
  closeDialog: () => void;
  fullName: string;
}

const WorkDialog: React.FC<WorkDialogProps> = (props) => {
  const { workExperience, closeDialog, fullName = '' } = props;
  const styles = useStyle();
  const classes = useStyles();

  const handleClose = () => closeDialog();

  return (
    <Dialog
      onClose={handleClose}
      open={workExperience?.length !== 0}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main'>{`سابقه ی شغلی ${fullName}`}</Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Grid container spacing={2} mt={2}>
          {workExperience.map((item: TWorkExperience) => (
            <Grid item lg={4} key={item.id}>
              <WorkExperienceCard workExperience={item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Dialog>
  );
};

export default WorkDialog;
